import { DottedKey, Inheritance } from '../../field-definitions/entities/field-definition.entity';

export interface FieldInheritance {
    DottedKey: DottedKey;
    ParentValue: null | string | object;
    Value: null | string | object;
    Inheritance: Inheritance;
    Broken: boolean;
}

export class RecordInheritance {
    readonly #recordInheritance: Record<DottedKey, FieldInheritance>;

    constructor(recordInheritance: Record<DottedKey, FieldInheritance>) {
        this.#recordInheritance = recordInheritance;
    }

    getFieldInheritance(dottedKey: DottedKey): FieldInheritance | undefined {
        return this.#recordInheritance[dottedKey];
    }
}
